<template>
  <div id="stand-add-or-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="createLoading && form == null" key="create-loading" />
        <el-row v-else-if="form != null" key="content">
          <el-row :gutter="10">
            <el-col :span="24" class="mt-3">
              <el-row :gutter="10">
                <el-col :span="12">
                  <div class="registerform-input-container">
                    <div class="custom-label">
                      <label>{{ $t("contentManagement.stands.standAddUpdate.title") }}</label>
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content">
                          <span>{{ $t("contentManagement.stands.standAddUpdate.titleMsg") }}</span>
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </div>
                    <el-input v-model="form.title"></el-input>
                    <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
                  </div>
                </el-col>

                <el-col :span="6">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{ $t("contentManagement.stands.standAddUpdate.saloon") }}</label>
                        <el-tooltip placement="top">
                          <div slot="content" class="custom-tooltip-content">
                            <span>{{ $t("contentManagement.stands.standAddUpdate.saloonMsg") }}</span>
                          </div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                      <el-tooltip :content="$t('contentManagement.stands.standAddUpdate.updateHallList')" placement="bottom">
                        <i class="cursor-pointer action-primary" :class="loading == 'salonlist' ? 'el-icon-loading' : 'el-icon-refresh'" @click="refreshSaloons"></i>
                      </el-tooltip>
                    </div>
                    <el-select v-model="form.saloonID" @clear="form.saloonID = null" clearable>
                      <el-option v-for="item in $store.state.stands.saloons.filter(x => x.isActive != false)" :key="item.id + '-option-key'" :value="item.id" :label="item.title"></el-option>
                    </el-select>
                    <span class="error">{{ $errorMessage("saloonID", validationErrors) }}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{ $t("contentManagement.stands.standAddUpdate.orderNo") }}</label>
                      </div>
                    </div>
                    <el-input-number v-model="form.orderNO" :min="1"></el-input-number>
                    <span class="error">{{ $errorMessage("orderNO", validationErrors) }}</span>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="10" key="content" v-if="form">
                <el-col :span="12" class="mt-3 mb-3">
                  <div class="registerform-input-container">
                    <div class="custom-label">
                      <label>{{ $t("contentManagement.stands.standAddUpdate.logo") }}</label>
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content">
                          <span>{{ $t("contentManagement.stands.standAddUpdate.logoMsg") }}</span>
                        </div>
                        <i v-if="logoPercent > 0" class="el-icon-loading"></i>
                        <i class="el-icon-info" v-else></i>
                      </el-tooltip>
                    </div>
                    <div class="mage-maker drag" :style="{ background: form.image ? `url(${$imageus + form.image + '?width=500&height=500&mode=contain'})` : 'none', 'border-radius': '5px' }">
                      <el-upload :onProgress="logoProgress" :style="{ opacity: !!form.image ? '0' : '1' }" class="avatar-uploader" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=stand&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" drag :show-file-list="false" :on-success="logoSuccess">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text" v-html="$t('generic.uploadText')"></div>
                      </el-upload>
                    </div>

                    <!-- <el-upload :onProgress="logoProgress" :style="{ opacity: !!form.cover ? '0' : '1' }" class="avatar-uploader" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=stand&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" :on-success="logoSuccess">
                      <img v-if="form.image" :src="$imageus + form.image + '?width=500&height=500&mode=contain'" class="avatar" />
                      <i v-else class="fas fa-plus avatar-uploader-icon"></i>
                    </el-upload> -->
                    <span class="error">{{ $errorMessage("image", validationErrors) }}</span>
                  </div>
                </el-col>

                <el-col :span="12" class="mt-3 mb-3">
                  <div class="registerform-input-container">
                    <div class="custom-label">
                      <label>{{ $t("contentManagement.stands.standAddUpdate.cover") }}</label>
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content">
                          <span>{{ $t("contentManagement.stands.standAddUpdate.coverMsg") }}</span>
                        </div>
                        <i v-if="logoPercent2 > 0" class="el-icon-loading"></i>
                        <i class="el-icon-info" v-else></i>
                      </el-tooltip>
                    </div>
                    <div class="mage-maker drag" :style="{ background: form.cover ? `url(${$imageus + form.cover + '?width=1120&height=500&mode=cover'})` : 'none', 'border-radius': '5px' }">
                      <el-upload :onProgress="logoProgress2" :style="{ opacity: !!form.cover ? '0' : '1' }" class="avatar-uploader cover-photo" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=standCover&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" drag :show-file-list="false" :on-success="logoSuccess2">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text" v-html="$t('generic.uploadText')"></div>
                      </el-upload>
                    </div>
                    <span class="error">{{ $errorMessage("cover", validationErrors) }}</span>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="10">
                <el-col :span="24">
                  <div class="registerform-input-container">
                    <div class="custom-label">
                      <label>{{ $t("contentManagement.stands.standAddUpdate.content") }}</label>
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content">
                          <span>{{ $t("contentManagement.stands.standAddUpdate.contentDetails") }}</span>
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </div>
                    <quill-editor ref="myQuillEditor" @ready="onEditorReady($event)" :options="editorOption" v-model="form.detail" />
                    <span class="error">{{ $errorMessage("detail", validationErrors) }}</span>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-if="form">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="enableContacts = !enableContacts">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.stands.standAddUpdate.contact.contact") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("contentManagement.stands.standAddUpdate.contact.contactMsg") }}</span>
                    <span class="text-danger" v-if="validationErrors.some(x => x.key.includes('location')) || validationErrors.some(x => x.key.includes('socialMedia'))" v-html="$t('contentManagement.stands.standAddUpdate.incorrectFields', [validationErrors.filter(x => x.key.includes('location')).length])"></span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="enableContacts ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="enableContacts">
                    <el-row :gutter="10">
                      <el-col :span="24" class="info-card">
                        <div class="header">{{ $t("contentManagement.stands.standAddUpdate.contact.addressInformation") }}</div>

                        <el-row :gutter="10" class="mt-3">
                          <el-col :span="24">
                            <div class="registerform-input-container">
                              <div class="custom-label">
                                <label>{{ $t("contentManagement.stands.standAddUpdate.contact.addressHeader") }}</label>
                                <el-tooltip placement="top">
                                  <div slot="content" class="custom-tooltip-content">
                                    <span>{{ $t("contentManagement.stands.standAddUpdate.contact.addressHeaderMsg") }}</span>
                                  </div>
                                  <i class="el-icon-info"></i>
                                </el-tooltip>
                              </div>
                              <el-input @change="venueChanged = true" v-model="form.location.venue" :class="$inputError('location.Venue', validationErrors)"></el-input>
                              <span class="error">{{ $errorMessage("location.Venue", validationErrors) }}</span>
                            </div>
                          </el-col>

                          <el-col :span="24" class="mt-3">
                            <div class="registerform-input-container">
                              <div class="title">
                                <div class="custom-label">
                                  <label>{{ $t("contentManagement.stands.standAddUpdate.contact.openAdres") }}</label>
                                  <!-- <el-tooltip placement="top">
                                    <div slot="content" class="custom-tooltip-content"><span>Belirteceğiniz başlık tanımlayacağınız adres bilgileri için başlık yayınlanır.</span></div>
                                    <i class="el-icon-info"></i>
                                  </el-tooltip> -->
                                </div>
                              </div>
                              <el-input @change="addressChanged = true" type="textarea" v-model="form.location.address" :rows="4" :class="$inputError('location.Address', validationErrors)"></el-input>
                              <span class="error">{{ $errorMessage("location.Address", validationErrors) }}</span>
                            </div>
                          </el-col>

                          <el-col :span="12" class="mt-3">
                            <div class="registerform-input-container">
                              <div class="title">
                                <div class="custom-label">
                                  <label>{{ $t("contentManagement.stands.standAddUpdate.contact.country") }}</label>
                                  <!-- <el-tooltip placement="top">
                                    <div slot="content" class="custom-tooltip-content"><span>Belirteceğiniz başlık tanımlayacağınız adres bilgileri için başlık yayınlanır.</span></div>
                                    <i class="el-icon-info"></i>
                                  </el-tooltip> -->
                                </div>
                              </div>
                              <el-input v-model="form.location.country" :class="$inputError('location.Country', validationErrors)"></el-input>
                              <span class="error">{{ $errorMessage("location.Country", validationErrors) }}</span>
                            </div>
                          </el-col>

                          <el-col :span="12" class="mt-3">
                            <div class="registerform-input-container">
                              <div class="title">
                                <div class="custom-label">
                                  <label>{{ $t("contentManagement.stands.standAddUpdate.contact.city") }}</label>
                                  <!-- <el-tooltip placement="top">
                                    <div slot="content" class="custom-tooltip-content"><span>Belirteceğiniz başlık tanımlayacağınız adres bilgileri için başlık yayınlanır.</span></div>
                                    <i class="el-icon-info"></i>
                                  </el-tooltip> -->
                                </div>
                              </div>
                              <el-input v-model="form.location.city" :class="$inputError('location.City', validationErrors)"></el-input>
                              <span class="error">{{ $errorMessage("location.City", validationErrors) }}</span>
                            </div>
                          </el-col>
                        </el-row>
                      </el-col>

                      <el-col :span="24" class="info-card mt-3">
                        <div class="header">{{ $t("contentManagement.stands.standAddUpdate.contact.mapLocation") }}</div>
                        <el-row :gutter="10">
                          <el-col :span="24" class="mt-3">
                            <div class="registerform-input-container">
                              <div class="custom-label">
                                <label>{{ $t("contentManagement.stands.standAddUpdate.contact.searchLocation") }}</label>
                                <el-tooltip placement="top">
                                  <div slot="content" class="custom-tooltip-content">
                                    <span>{{ $t("contentManagement.stands.standAddUpdate.contact.searchLocationMsg") }}</span>
                                  </div>
                                  <i class="el-icon-info"></i>
                                </el-tooltip>
                                <i class="fas fa-trash text-danger ml-auto cursor-pointer " @click="resetMap" v-if="form.location.longtitude != null || form.location.latitude != null"></i>
                              </div>
                              <gmap-autocomplete class="introInput" @place_changed="placeChanged" :placeholder="$t('event.textbox.search')">
                                <template v-slot:input="slotProps">
                                  <v-text-field style="width: 100%" id="addressInput" prepend-inner-icon="place" ref="input" v-on:listeners="slotProps.listeners" v-on:attrs="slotProps.attrs"></v-text-field>
                                </template>
                              </gmap-autocomplete>
                              <span class="error">{{ $errorMessage("location.Latitude", validationErrors) }}</span>
                            </div>
                          </el-col>

                          <el-col :span="24" class="mt-3">
                            <div class="registerform-input-container">
                              <div class="custom-label">
                                <label>{{ $t("contentManagement.stands.standAddUpdate.contact.chooseLocation") }}</label>
                                <el-tooltip placement="top">
                                  <div slot="content" class="custom-tooltip-content">
                                    <span>{{ $t("contentManagement.stands.standAddUpdate.contact.chooseLocationMsg") }}</span>
                                  </div>
                                  <i class="el-icon-info"></i>
                                </el-tooltip>
                              </div>
                              <GmapMap :center="getLatLng" :zoom="7" map-type-id="terrain" style="width: 100%; height: 300px; border-radius: 8px; overflow: hidden;" ref="mapRef">
                                <GmapMarker :key="form.location.latitude + '-latitude'" :position="getLatLng" :clickable="true" :draggable="true" @dragend="setCenter" ref="marker" />
                              </GmapMap>
                              <span class="error">{{ $errorMessage("location.Longtitude", validationErrors) }}</span>
                            </div>
                          </el-col>
                        </el-row>
                      </el-col>

                      <el-col :span="24" class="info-card mt-3">
                        <div class="header" :class="{ 'text-danger': validationErrors.some(x => x.key.includes('organizator')) }">{{ $t("contentManagement.stands.standAddUpdate.contact.contact") }}</div>
                        <div class="contacts-wrapper">
                          <div class="contact-container" :class="{ passive: !form.organizator.mobilePhoneIsActive }">
                            <i class="fas fa-mobile-alt"></i>
                            <el-input v-model="form.organizator.mobilePhone" :class="$inputError('organizator.MobilePhone', validationErrors)" :placeholder="$t('contentManagement.stands.standAddUpdate.contact.mobilePhone')"></el-input>
                            <el-switch v-model="form.organizator.mobilePhoneIsActive"></el-switch>
                          </div>
                          <div class="contact-container" :class="{ passive: !form.organizator.phoneNumberIsActive }">
                            <i class="el-icon-phone"></i>
                            <el-input v-model="form.organizator.phoneNumber" :class="$inputError('organizator.PhoneNumber', validationErrors)" :placeholder="$t('contentManagement.stands.standAddUpdate.contact.phoneNumber')"></el-input>
                            <el-switch v-model="form.organizator.phoneNumberIsActive"></el-switch>
                          </div>
                          <div class="contact-container" :class="{ passive: !form.organizator.emailIsActive }">
                            <i class="fas fa-envelope"></i>
                            <el-input v-model="form.organizator.email" :class="$inputError('organizator.Email', validationErrors)" :placeholder="$t('contentManagement.stands.standAddUpdate.contact.email')"></el-input>
                            <el-switch v-model="form.organizator.emailIsActive"></el-switch>
                          </div>
                        </div>
                      </el-col>

                      <el-col :span="24" class="info-card mt-3">
                        <div class="header">
                          <span :class="{ 'text-danger': validationErrors.some(x => x.key.includes('socialMedia')) }">{{ $t("contentManagement.stands.standAddUpdate.contact.social") }}</span>
                        </div>
                        <div class="contacts-wrapper">
                          <div class="contact-container" :class="{ passive: !form.socialMedia.twitterIsACtive }">
                            <i class="fab fa-twitter socials twitter-color"></i>
                            <el-input v-model="form.socialMedia.twitter">
                              <template slot="prepend">
                                https://www.twitter.com/
                              </template>
                            </el-input>
                            <el-switch v-model="form.socialMedia.twitterIsACtive"></el-switch>
                          </div>
                          <div class="contact-container" :class="{ passive: !form.socialMedia.linkedInIsActive }">
                            <i class="fab fa-linkedin socials linkedin-color"></i>
                            <el-input v-model="form.socialMedia.linkedIn">
                              <template slot="prepend">
                                https://www.linkedin.com/
                              </template>
                            </el-input>
                            <el-switch v-model="form.socialMedia.linkedInIsActive"></el-switch>
                          </div>
                          <div class="contact-container" :class="{ passive: !form.socialMedia.facebookIsActive }">
                            <i class="fab fa-facebook-square socials facebook-color"></i>
                            <el-input v-model="form.socialMedia.facebook">
                              <template slot="prepend">
                                https://www.facebook.com/
                              </template>
                            </el-input>
                            <el-switch v-model="form.socialMedia.facebookIsActive"></el-switch>
                          </div>
                          <div class="contact-container" :class="{ passive: !form.socialMedia.instagramIsActive }">
                            <i class="fab fa-instagram socials instagram-color"></i>
                            <el-input v-model="form.socialMedia.instagram">
                              <template slot="prepend">
                                https://www.instagram.com/
                              </template>
                            </el-input>
                            <el-switch v-model="form.socialMedia.instagramIsActive"></el-switch>
                          </div>
                          <div class="contact-container" :class="{ passive: !form.socialMedia.youtubeIsActive }">
                            <i class="fab fa-youtube socials youtube-color"></i>
                            <el-input v-model="form.socialMedia.youtube">
                              <template slot="prepend">
                                https://www.youtube.com/
                              </template>
                            </el-input>
                            <el-switch v-model="form.socialMedia.youtubeIsActive"></el-switch>
                          </div>
                          <div class="contact-container" :class="{ passive: !form.socialMedia.websiteIsActive }">
                            <i class="fas fa-link socials link-color"></i>
                            <el-input v-model="form.socialMedia.website" :class="$inputError('socialMedia.Website', validationErrors)">
                              <template slot="prepend">
                                https://
                              </template>
                            </el-input>
                            <el-switch v-model="form.socialMedia.websiteIsActive"></el-switch>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-if="form">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="enableLinks = !enableLinks">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.stands.standAddUpdate.links.links") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("contentManagement.stands.standAddUpdate.links.linkMsg") }}</span>
                    <span class="text-danger" v-if="validationErrors.some(x => x.key.includes('links'))" v-html="$t('contentManagement.stands.standAddUpdate.incorrectFields', [validationErrors.filter(x => x.key.includes('links')).length])"></span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="enableLinks ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="enableLinks">
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <template v-if="form.links.length > 0">
                          <div class="link-area-title">
                            <div></div>
                            <div>{{ $t("contentManagement.stands.standAddUpdate.links.title") }}</div>
                            <div>{{ $t("contentManagement.stands.standAddUpdate.links.url") }}</div>
                            <div>{{ $t("contentManagement.stands.standAddUpdate.links.view") }}</div>
                            <div></div>
                          </div>
                          <draggable :list="form.links" tag="div" handle=".el-icon-s-grid" class="list-group-o link-area-container" v-bind="dragOptions" @start="dragList = true" @end="dragList = false">
                            <div class="item" v-for="(item, index) in form.links" :key="index + '-links-key'" :class="{ passive: !item.isActive }">
                              <div class="table-icon">
                                <i class="el-icon-s-grid burger"></i>
                              </div>
                              <div class="img-title">
                                <el-input v-model="item.title" :class="$inputError('links[' + index + '].Title', validationErrors)"></el-input>
                              </div>
                              <div>
                                <el-input v-model="item.url" :class="$inputError('links[' + index + '].URL', validationErrors)"></el-input>
                              </div>
                              <div><el-switch v-model="item.isActive"></el-switch></div>
                              <div style="display:flex; flex-direction:row;gap:.5rem">
                                <el-tooltip class="" effect="dark" :content="$t('event.buttons.delete')" placement="top">
                                  <el-popconfirm @confirm="form.links.splice(index, 1)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                                    <el-button slot="reference" type="danger" icon="fas fa-trash" size="mini" circle></el-button>
                                  </el-popconfirm>
                                </el-tooltip>
                              </div>
                            </div>
                          </draggable>
                        </template>
                        <el-alert v-else :show-icon="true" type="info" :title="$t('contentManagement.stands.standAddUpdate.links.noLinkMessage')"></el-alert>

                        <el-col :span="24" class="d-flex justify-content-end mt-3">
                          <el-button size="mini" round type="primary" icon="fas fa-plus" @click="addLinks">{{ $t("contentManagement.stands.standAddUpdate.links.addLink") }}</el-button>
                        </el-col>
                      </el-col>
                    </el-row>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-if="form">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="enableGallery = !enableGallery">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.stands.standAddUpdate.gallery.gallery") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("contentManagement.stands.standAddUpdate.gallery.galleryMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="enableGallery ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="enableGallery">
                    <upgrade-overlay v-if="false" height="200px"></upgrade-overlay>
                    <el-row :gutter="10" class="mt-3" v-else>
                      <el-col :span="24">
                        <template v-if="form.gallery.length > 0">
                          <div class="gallery-area-title">
                            <div></div>
                            <div>{{ $t("contentManagement.stands.standAddUpdate.gallery.media") }}</div>
                            <div>{{ $t("contentManagement.stands.standAddUpdate.gallery.view") }}</div>
                            <div></div>
                          </div>
                          <draggable :list="form.gallery" tag="div" handle=".el-icon-s-grid" class="list-group-o gallery-area-container" v-bind="dragOptions" @start="dragList = true" @end="dragList = false">
                            <div class="item" v-for="(item, index) in form.gallery" :key="index + '-key-gallery'" :class="{ passive: !item.isActive }">
                              <div class="table-icon">
                                <i class="el-icon-s-grid burger"></i>
                              </div>
                              <div class="img-title">
                                <div class="img-title-alt">
                                  <img :src="$imageus + item.url + '?width=160&height=120&mode=cover'" style="object-fit:cover; max-width:160px; max-height: 120px;;" alt="" v-if="item.type == 0" />
                                  <template v-else>
                                    <iframe style="border-radius: 8px;" width="160px" height="120px" :src="'https://www.youtube.com/embed/' + createYoutubeUrl(item.url)" v-if="item.type == 1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                  </template>

                                  <div class="networking-title">
                                    {{ item.title }}
                                    <span v-if="item.type == 1">{{ $t("contentManagement.stands.standAddUpdate.gallery.youtubeVideo") }}</span>
                                    <span v-if="item.type == 0">{{ $t("contentManagement.stands.standAddUpdate.gallery.photo") }}</span>
                                  </div>
                                </div>
                              </div>
                              <div><el-switch v-model="item.isActive"></el-switch></div>
                              <div style="display:flex; flex-direction:row;gap:.2rem">
                                <el-tooltip class="" effect="dark" :content="$t('event.buttons.edit')" placement="top">
                                  <el-button
                                    type="primary"
                                    icon="fas fa-pen"
                                    size="mini"
                                    circle
                                    @click="
                                      activeIndex = index;
                                      updateForm = JSON.parse(JSON.stringify(item));
                                      mediaDialog = true;
                                    "
                                  ></el-button>
                                </el-tooltip>
                                <el-tooltip class="" effect="dark" :content="$t('event.buttons.delete')" placement="top">
                                  <el-popconfirm @confirm="deleteGalleryItem(index)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                                    <el-button slot="reference" type="danger" icon="fas fa-trash" :loading="loading == 'deleteGalleryItem-' + index" size="mini" circle></el-button>
                                  </el-popconfirm>
                                </el-tooltip>
                              </div>
                            </div>
                          </draggable>
                        </template>
                        <el-alert v-else :show-icon="true" type="info" :title="$t('contentManagement.stands.standAddUpdate.gallery.noGalleryMessage')"></el-alert>
                        <el-col :span="24" class="d-flex justify-content-end mt-3">
                          <el-button
                            size="mini"
                            round
                            type="primary"
                            icon="fas fa-plus"
                            @click="
                              activeIndex = null;
                              updateForm = null;
                              mediaDialog = true;
                            "
                          >
                            {{ $t("contentManagement.stands.standAddUpdate.gallery.addMedia") }}
                          </el-button>
                        </el-col>
                      </el-col>
                    </el-row>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-if="form">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="enableStaffs = !enableStaffs">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.stands.standAddUpdate.authorities.authorities") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span class="text-danger" v-if="validationErrors.some(x => x.key.includes('managers'))" v-html="$t('contentManagement.stands.standAddUpdate.incorrectFields', [validationErrors.filter(x => x.key.includes('managers')).length])"></span>
                    <span>{{ $t("contentManagement.stands.standAddUpdate.authorities.authoritiesMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="enableStaffs ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="enableStaffs">
                    <upgrade-overlay v-if="false" height="200px"></upgrade-overlay>

                    <el-row :gutter="10" class="mt-3" v-else>
                      <el-col :span="24">
                        <div class="add-manager-container">
                          <div class="add-manager-title">
                            <div class="add-m-input">
                              <el-select v-model="lastParticiId" remote :remote-method="remoteMethod" clearable @clear="lastParticiId = null" :placeholder="$t('contentManagement.stands.standAddUpdate.authorities.selectAuth')" filterable>
                                <el-option v-for="(item, participantIndex) in remoteList" :key="participantIndex + '-participants-id'" :label="item.firstName + ' ' + item.lastName" :value="item.id"></el-option>
                              </el-select>
                            </div>
                            <div class="add-m-btn">
                              <el-button round size="small" type="primary" @click="addManager">{{ $t("contentManagement.stands.standAddUpdate.authorities.add") }}</el-button>
                            </div>
                          </div>

                          <template v-if="form.managers.length > 0">
                            <div class="managers-title custom-grid-table-header">
                              <div></div>
                              <div>{{ $t("contentManagement.stands.standAddUpdate.authorities.authorized") }}</div>
                              <div>{{ $t("contentManagement.stands.standAddUpdate.authorities.task") }}</div>
                              <div class="text-center">{{ $t("contentManagement.stands.standAddUpdate.authorities.view") }}</div>
                              <div></div>
                            </div>

                            <draggable :list="form.managers" tag="div" handle=".el-icon-s-grid" class="list-group-o managers-container" v-bind="dragOptions" @start="dragList = true" @end="dragList = false">
                              <div class="item" v-for="(item, index) in form.managers" :key="index + '-manager-list-key'" :class="{ passive: !item.isActive }">
                                <div class="table-icon">
                                  <i class="el-icon-s-grid burger"></i>
                                </div>

                                <div class="participant-card-mini">
                                  <div class="participant-card-mini-right">
                                    <div class="participant-card-mini-num">#{{ item.participant.participantNO }}</div>
                                    <div class="participant-card-mini-title">{{ item.participant.firstName + " " + item.participant.lastName }}</div>
                                    <div class="participant-card-mini-container">
                                      <span>
                                        <i class="fas fa-circle" :style="{ color: $store.state.tags.items.find(x => x.id == item.participant.tagID).color }"></i>
                                        {{ $store.state.tags.items.find(x => x.id == item.participant.tagID).title }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div>
                                  <el-select v-model="item.type" v-if="getEnums" :class="$inputError('managers[' + index + '].Type', validationErrors)">
                                    <el-option v-for="(manager, index) in getEnums.find(x => x.title == 'StandManagerType').enums" :label="manager.displayName" :value="manager.key" :key="index + '-key-' + manager.key"></el-option>
                                  </el-select>
                                </div>
                                <div class="text-center"><el-switch v-model="item.isActive"></el-switch></div>
                                <div style="display:flex; flex-direction:row;gap:.5rem">
                                  <el-tooltip class="" effect="dark" :content="$t('event.buttons.delete')" placement="top">
                                    <el-popconfirm @confirm="form.managers.splice(index, 1)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                                      <el-button slot="reference" type="danger" icon="fas fa-trash" size="mini" circle></el-button>
                                    </el-popconfirm>
                                  </el-tooltip>
                                </div>
                              </div>
                            </draggable>
                          </template>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-if="form">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="enableQuestions = !enableQuestions">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.stands.standAddUpdate.checkinQuestions.checkinQuestions") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("contentManagement.stands.standAddUpdate.checkinQuestions.checkinQuestionsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="enableQuestions ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="enableQuestions">
                    <upgrade-overlay height="200px" v-if="false"></upgrade-overlay>
                    <QuestionLibrary :id="form.id" v-if="enableQuestions" :type="4" />
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-if="form">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.stands.standAddUpdate.settings.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("contentManagement.stands.standAddUpdate.settings.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.checkInTypes.length > 0 ? 'sactive' : 'swaiting'" style="position:relative;">
                      <upgrade-overlay v-if="false" position="absolute" :onlyButton="true" size="mini"></upgrade-overlay>
                      <div class="custom-set-inner">
                        <i class="fas fa-map-marker-alt"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("contentManagement.stands.standAddUpdate.settings.checkIn") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("contentManagement.stands.standAddUpdate.settings.checkInMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fcenter">
                        <el-select v-model="form.checkInTypes" multiple>
                          <el-option v-for="(item, enumsIndex) in getEnums.find(x => x.title == 'StandCheckInType').enums" :label="item.displayName" :key="enumsIndex + '-check-in-type'" :value="item.key"></el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("contentManagement.stands.standAddUpdate.settings.view") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("contentManagement.stands.standAddUpdate.settings.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="form.enableCustomTags ? 'sactive' : ''">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.enableCustomTags ? 'fa-tags' : 'fa-tags'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("contentManagement.stands.standAddUpdate.settings.useTags") }}
                          </label>
                          <span>{{ $t("contentManagement.stands.standAddUpdate.settings.useTagsMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.enableCustomTags"></el-switch>
                      </div>
                      <div class="custom-set-actions fcenter mt-3" v-show="form.enableCustomTags">
                        <CustomTag :value="form.customTags" v-model="form.customTags"></CustomTag>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="createLoading == false && form != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("contentManagement.stands.standAddUpdate.close") }}</el-button>
        <template v-if="form.id">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash">{{ $t("contentManagement.stands.standAddUpdate.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveLoading'" :disabled="loading == 'saveLoading'" @click="save">{{ $t("contentManagement.stands.standAddUpdate.save") }}</el-button>
      </div>
    </div>

    <el-dialog :visible.sync="mediaDialog" :close-on-click-modal="false" :title="updateForm ? $t('contentManagement.stands.standAddUpdate.gallery.editMedia') : $t('contentManagement.stands.standAddUpdate.gallery.addMedia')" class="medium" center append-to-body destroy-on-close>
      <MediaStandAddUpdate @closeDialog="mediaDialog = false" v-if="mediaDialog" @deleteMe="deleteGalleryItem" :data="updateForm" @itemUpdated="mediaUpdated" :activeIndex="activeIndex" />
    </el-dialog>
  </div>
</template>

<script>
import QuestionLibrary from "../components/register-form/QuestionLibrary.vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import draggable from "vuedraggable";
import axios from "axios";
import ItemInfo from "./ItemInfo";
import MediaStandAddUpdate from "./MediaStandAddUpdate.vue";
export default {
  components: { ItemInfo, quillEditor, draggable, MediaStandAddUpdate, QuestionLibrary },
  name: "StandAddUpdate",
  props: ["standId"],
  data() {
    return {
      customTagsKey: +new Date(),
      remoteList: [],
      enableLinks: false,
      enableContacts: false,
      enableStaffs: false,
      enableQuestions: false,
      enableGallery: false,
      settingsDock: false,
      activeIndex: null,
      activePanel: null,
      lastParticiId: null,
      dragList: false,
      mediaDialog: false,
      updateForm: null,
      form: null,
      editorOption: {
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"], [{ color: [] }, { background: [] }], ["clean"], ["link", "image"]],
          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          }
        }
      },
      quillUploading: false,
      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
      venueChanged: false,
      addressChanged: false,
      logoPercent2: 0,
      loading: false,
      timeout: null,
      createLoading: false
    };
  },
  async created() {
    await Promise.all([this.$store.dispatch("getParticipants"), this.$store.dispatch("getStandSaloons")]);
    if (this.standId != null && this.standId != null) {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.createLoading = true;
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("getStand", this.standId);

        var newForm = res.data.data.item;
        this.$nextTick(() => {
          if (newForm.socialMedia.instagram != null) {
            newForm.socialMedia.instagram = newForm.socialMedia.instagram.replaceAll("https://www.instagram.com/", "");
          }
          if (newForm.socialMedia.twitter != null) {
            newForm.socialMedia.twitter = newForm.socialMedia.twitter.replaceAll("https://www.twitter.com/", "");
          }
          if (newForm.socialMedia.linkedIn != null) {
            newForm.socialMedia.linkedIn = newForm.socialMedia.linkedIn.replaceAll("https://www.linkedin.com/", "");
          }
          if (newForm.socialMedia.facebook != null) {
            newForm.socialMedia.facebook = newForm.socialMedia.facebook.replaceAll("https://www.facebook.com/", "");
          }
          if (newForm.socialMedia.youtube != null) {
            newForm.socialMedia.youtube = newForm.socialMedia.youtube.replaceAll("https://www.youtube.com/", "");
          }
          if (newForm.socialMedia.website != null) {
            newForm.socialMedia.website = newForm.socialMedia.website.replaceAll("https://", "");
          }
        });
        this.form = newForm;
        if (this.form.location.venue != "" && this.form.location.venue != null) {
          this.venueChanged = true;
        }

        if (this.form.location.address != "" && this.form.location.address != null) {
          this.addressChanged = true;
        }
        this.createLoading = false;
      }, 500);
    }
  },
  methods: {
    async deleteGalleryItem(index) {
      this.loading = "deleteGalleryItem-" + index;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout ==
        setTimeout(() => {
          this.form.gallery.splice(index, 1);
          this.loading = false;
        }, 500);
    },
    async refreshSaloons() {
      this.loading = "salonlist";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getStandSaloons");
        this.loading = false;
      }, 500);
    },
    mediaUpdated(item) {
      if (this.activeIndex != null) {
        var mindex = this.form.gallery.findIndex(x => x.id == this.activeIndex);
        this.form.gallery.splice(mindex, 1, item);
      } else {
        this.form.gallery.push(item);
      }
    },
    addLinks() {
      this.form.links.push({
        id: null,
        title: this.$t("contentManagement.stands.standAddUpdate.links.newLink"),
        url: "https://"
      });
    },
    placeChanged(place) {
      this.form.location.venue = place.name;
      this.form.location.address = place.formatted_address;
      this.form.location.latitude = place.geometry.location.lat();
      this.form.location.longtitude = place.geometry.location.lng();
      this.$refs.mapRef.$mapPromise.then(map => {
        map.panTo({
          lat: this.form.location.latitude,
          lng: this.form.location.longtitude
        });
      });
    },
    async remoteMethod(query) {
      var res = await axios.post("/participant/list", { searchTerm: query, skip: 0, take: 20 });
      this.remoteList = res.data.data.items;
    },
    addManager() {
      if (this.lastParticiId != null) {
        var attende = this.remoteList.find(x => x.id == this.lastParticiId);
        var payload = {
          id: null,
          participantId: attende.id,
          isActive: true,
          type: null,
          participant: attende
        };
        if (this.form.managers.find(x => x.participantId == attende.id)) {
          this.$message.error(this.$t("contentManagement.networking.networkingAddUpdate.authorities.alreadyHas"));
        } else {
          this.form.managers.push(payload);
        }
      } else {
        this.$message.error(this.$t("contentManagement.networking.networkingAddUpdate.authorities.selectAuth"));
      }
      this.lastParticiId = null;
    },
    onEditorReady(editor) {
      editor.root.setAttribute("data-placeholder", this.$t("enterText"));
      editor.getModule("toolbar").addHandler("image", () => {
        this.selectLocalImage(editor);
      });
    },
    createYoutubeUrl(url) {
      var indexL = url.lastIndexOf("/");
      return url.slice(indexL + 1);
    },

    selectLocalImage(editor) {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.click();
      input.onchange = () => {
        const file = input.files[0];
        if (/^image\//.test(file.type)) {
          this.saveToServer(file, editor);
          this.quillUploading = "Image upload process started.";
        } else {
          //console.warn("You could only upload images.");
          this.quillUploading = "You could only upload images.";
          setTimeout(() => {
            this.quillUploading = false;
          }, 3000);
        }
      };
    },
    setCenter(event) {
      this.form.location.latitude = event.latLng.lat();
      this.form.location.longtitude = event.latLng.lng();
      this.$refs.mapRef.$mapPromise.then(map => {
        map.panTo({
          lat: this.form.location.latitude,
          lng: this.form.location.longtitude
        });
      });

      this.$geocoder.send(
        {
          lat: this.form.location.latitude,
          lng: this.form.location.longtitude
        },
        response => {
          if (response.results.length != 0) {
            document.getElementsByClassName("introInput")[0].value = response.results[0].formatted_address;
            if (this.addressChanged == false) {
              this.form.location.address = response.results[0].formatted_address;
            }
          }
        }
      );
    },
    saveToServer(file, editor) {
      const fd = new FormData();

      fd.append("image", file);
      const xhr = new XMLHttpRequest();
      xhr.open("POST", axios.defaults.baseURL + "event/uploadImage?uploadType=html&language=" + this.$i18n.locale, true);
      xhr.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("token"));

      xhr.onload = () => {
        if (xhr.status === 200) {
          const body = JSON.parse(xhr.responseText);
          if (body.alert.hasError == false) {
            const url = body.data.item.url;
            this.insertToEditor(url, editor);
            this.quillUploading = "Image upload process completed successfully.";
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          } else {
            this.$message.error(body.alert.message);
            this.quillUploading = body.alert.message;
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          }
        } else {
          this.quillUploading = xhr.statusText + " (Code: " + xhr.status + ")";
          setTimeout(() => {
            this.quillUploading = false;
          }, 3000);
        }
      };

      xhr.send(fd);
    },

    insertToEditor(url, editor) {
      editor.insertEmbed(editor.getSelection().index, "image", url);
    },

    addLink() {
      this.form.links.push({
        title: null,
        url: null
      });
    },
    deleteLink(index) {
      this.form.links.splice(index, 1);
    },
    deleteItem() {
      this.$emit("deleteMe", this.form.id);
      this.$emit("closeDialog");
    },
    resetMap() {
      this.form.location.latitude = null;
      this.form.location.longtitude = null;
    },
    async save() {
      this.loading = "saveLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var location = this.form.location;
        if (location.latitude != null && location.longtitude != null) {
          location.latitude = location.latitude.toString();
          location.longtitude = location.longtitude.toString();
        }
        var form = JSON.parse(JSON.stringify(this.form));
        // https://www.twitter.com/ https://www.linkedin.com/ https://www.facebook.com/ https://www.instagram.com/ https://www.youtube.com/  https://
        if (form.socialMedia.instagram != null) {
          form.socialMedia.instagram = "https://www.instagram.com/" + form.socialMedia.instagram;
        }
        if (form.socialMedia.twitter != null) {
          form.socialMedia.twitter = "https://www.twitter.com/" + form.socialMedia.twitter;
        }
        if (form.socialMedia.linkedIn != null) {
          form.socialMedia.linkedIn = "https://www.linkedin.com/" + form.socialMedia.linkedIn;
        }
        if (form.socialMedia.facebook != null) {
          form.socialMedia.facebook = "https://www.facebook.com/" + form.socialMedia.facebook;
        }
        if (form.socialMedia.youtube != null) {
          form.socialMedia.youtube = "https://www.youtube.com/" + form.socialMedia.youtube;
        }
        if (form.socialMedia.website != null) {
          form.socialMedia.website = "https://" + form.socialMedia.website;
        }

        var res = await this.$store.dispatch("standAddUpdate", { ...form, ...location });
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          var newForm = res.data.data.item;
          this.$nextTick(() => {
            if (newForm.socialMedia.instagram != null) {
              newForm.socialMedia.instagram = newForm.socialMedia.instagram.replaceAll("https://www.instagram.com/", "");
            }
            if (newForm.socialMedia.twitter != null) {
              newForm.socialMedia.twitter = newForm.socialMedia.twitter.replaceAll("https://www.twitter.com/", "");
            }
            if (newForm.socialMedia.linkedIn != null) {
              newForm.socialMedia.linkedIn = newForm.socialMedia.linkedIn.replaceAll("https://www.linkedin.com/", "");
            }
            if (newForm.socialMedia.facebook != null) {
              newForm.socialMedia.facebook = newForm.socialMedia.facebook.replaceAll("https://www.facebook.com/", "");
            }
            if (newForm.socialMedia.youtube != null) {
              newForm.socialMedia.youtube = newForm.socialMedia.youtube.replaceAll("https://www.youtube.com/", "");
            }
            if (newForm.socialMedia.website != null) {
              newForm.socialMedia.website = newForm.socialMedia.website.replaceAll("https://", "");
            }
          });
          this.$nextTick(async () => {
            this.form = newForm;
            await this.$store.dispatch("getStands");
          });
        }
        this.loading = false;
      }, 500);
    },

    clean() {
      this.form.location.address = null;
      this.form.location.city = null;
      this.form.location.country = null;
      this.form.location.venue = null;
      this.form.location.latitude = null;
      this.form.location.longtitude = null;
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data.item.url;
      }
    },
    logoProgress2(event) {
      this.logoPercent2 = event.percent;
    },
    logoSuccess2(response) {
      this.logoPercent2 = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.cover = response.data.item.url;
      }
    }
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    getLatLng() {
      if (this.form.location.latitude == null || this.form.location.latitude == "") {
        return {
          lat: 41.0054958,
          lng: 28.8720965
        };
      }
      return {
        lat: parseFloat(this.form.location.latitude),
        lng: parseFloat(this.form.location.longtitude)
      };
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    getEnums() {
      return this.$store.getters.getEnums;
    },
    getParticipantsItems() {
      return this.$store.getters.getParticipantsItems;
    }
  }
};
</script>
<style lang="less" scoped>
.introInput {
  background-color: #fbfbfb;
  border-radius: 8px;
  border: 0.5px solid #d6d9d9;
  color: #505763;
  font-size: 14px;
  font-weight: 400;
  height: 42px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  box-sizing: border-box;
  width: 100%;

  &:focus {
    border-color: #03658c;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    outline: 0;
  }

  &:focus-visible {
    outline: 0;
  }

  &:hover {
    border-color: #c0c4cc;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

    &:focus {
      border-color: #03658c;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      outline: 0;
    }
  }
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}

.control-point-info {
  padding: 1rem 2rem;
  .container-info {
    background-color: #eaeaea;
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    border-radius: 8px;
    .qr-img {
      i {
        font-size: 40px;
      }
    }
    .title {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      .el-button {
        width: 150px;
        font-weight: 600;
      }
    }
  }
}
.add-manager-container {
  display: flex;
  flex-direction: column;
  .add-manager-title {
    flex-direction: row;
    display: flex;
    gap: 1rem;
    align-items: center;
    margin-bottom: 1rem;
    border-radius: 8px;
    .add-m-btn {
      flex-shrink: 0;
    }
    .add-m-input {
      width: 100%;
    }
  }
}

.contacts-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.contact-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background: #f1f1f1;
  border-radius: 8px;
  padding: 10px 8px;
  margin-bottom: 8px;
  gap: 0.5rem;

  i {
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    font-size: 20px;
    color: #505763;
    margin-right: 6px;
    flex-shrink: 0;
  }
  .el-input {
    flex-grow: 1;
  }
  .el-switch {
    flex-shrink: 0;
  }
  &.passive {
    background-color: #fff2f2 !important;
  }
}
.registerform-input-container {
  .el-upload {
    width: 100% !important;
  }
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    i {
      cursor: pointer;
    }
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    gap: 0.3rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
.managers-title {
  grid-template-columns: 30px 1.5fr 1fr 90px 60px;
  gap: 1rem;
}

.info-card {
  .header {
    color: #606266;
    font-weight: bold;
    font-size: 14px;
    display: flex;
    align-items: center;
    padding: 10px;
    border-radius: 8px;
    background-color: #eaeaea;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }
  .sub-head {
    font-weight: 500;
    margin-bottom: 1rem;
  }
}
.managers-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  .item {
    .img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;
      .img-title-alt {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        .networking-title {
          display: flex;
          flex-direction: column;
          gap: 0.1rem;
          color: #292f3b;
          font-weight: 600;
          & > span {
            color: #606266 !important;
            display: flex;
            flex-direction: row;
            align-items: center;
            font-weight: 500;
          }
        }
      }
      & > img {
        border-radius: 8px;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f3f3f3;
    &.passive {
      background-color: #ffe5e5 !important;
    }
    display: grid;
    grid-template-columns: 30px 1.5fr 1fr 90px 60px;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;

    gap: 1rem;
    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      cursor: pointer;
      &.me {
        color: #ccc;
      }
      font-size: 20px;
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
.circle-color-pick {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  flex-shrink: 0;
}
.cover-image {
  height: 250px;
}

.link-area-title {
  display: grid;
  grid-template-columns: 30px 1fr 1.5fr 90px 60px;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  background-color: #eaeaea;
  font-weight: bold;
  margin-bottom: 0.5rem;
  gap: 1rem;
}
.link-area-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  .item {
    .img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;
      .img-title-alt {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        .networking-title {
          display: flex;
          flex-direction: column;
          gap: 0.1rem;
          color: #292f3b;
          font-weight: 600;
          & > span {
            color: #606266 !important;
            display: flex;
            flex-direction: row;
            align-items: center;
            font-weight: 500;
          }
        }
      }
      & > img {
        border-radius: 8px;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f3f3f3;
    &.passive {
      background-color: #ffe5e5 !important;
    }
    display: grid;
    grid-template-columns: 30px 1fr 1.5fr 90px 60px;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;

    gap: 1rem;
    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      cursor: grab;
      color: #505763;

      &.me {
        color: #ccc;
      }
      font-size: 20px;
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}

.gallery-area-title {
  display: grid;
  grid-template-columns: 30px 1fr 90px 60px;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  background-color: #eaeaea;
  font-weight: bold;
  margin-bottom: 0.5rem;
  gap: 1rem;
}
.gallery-area-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  .item {
    .img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;
      .img-title-alt {
        display: flex;
        flex-direction: flex;
        gap: 0.5rem;
        align-items: center;
        & > img {
          border-radius: 8px;
        }
        .networking-title {
          display: flex;
          flex-direction: column;
          gap: 0.1rem;
          color: #292f3b;
          font-weight: 600;
          & > span {
            color: #606266 !important;
            display: flex;
            flex-direction: row;
            align-items: center;
            font-weight: 500;
          }
        }
      }
      & > img {
        border-radius: 8px;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f3f3f3;
    &.passive {
      background-color: #ffe5e5 !important;
    }
    display: grid;
    grid-template-columns: 30px 1fr 90px 60px;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;

    gap: 1rem;
    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      cursor: grab;
      color: #505763;
      font-size: 20px;
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
.model-base-mid {
  min-width: 1140px;
}
.model-base-small {
  min-width: 550px;
}
.model-base-mini {
  min-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/StandAddUpdate.vue